import { ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { AppSettings } from './app-settings'

@Injectable()
export class ToastService {

    private readonly connectionLostMessage =
        'שגיאת מערכת יש לבדוק חיבור לאינטרנט ולנסות שוב';

    constructor(private toastCtrl: ToastController) {}

    presentToast(message: string) {
        console.log("Toast : " , AppSettings.TOAST);
        let toastItem = AppSettings.TOAST;
        toastItem["message"] = message;
        toastItem["cssClass"] = "ToastClass"
        let toast = this.toastCtrl.create(toastItem);
        toast.present();
    }

    presentLongToast(message: string) {
        const toast = this.toastCtrl.create({
            message,
            duration: 5500,
            position: 'bottom',
            cssClass: 'ToastClass',
            showCloseButton: true,
            closeButtonText: 'סגור',
        });
        toast.present();
    }

    /**
     * Show real HTTP status + message when available.
     * Falls back to the connection-lost toast only for true offline / unreachable cases.
     */
    presentHttpError(err: any) {
        if (this.isConnectionLost(err)) {
            this.presentToast(this.connectionLostMessage);
            return;
        }

        const status = err && err.status != null ? Number(err.status) : null;
        const message = this.extractErrorMessage(err);
        let text = '';

        if (status != null && !isNaN(status) && status > 0) {
            text = message ? `HTTP ${status}: ${message}` : `HTTP ${status}`;
        } else if (message) {
            text = message;
        } else {
            text = this.connectionLostMessage;
        }

        this.presentLongToast(text);
    }

    /** Business/API body failure (HTTP 200 but sucsses=false). */
    presentServerError(response?: any, fallback?: string) {
        const message = this.extractErrorMessage(response)
            || (fallback && String(fallback).trim())
            || 'שגיאת מערכת';
        this.presentToast(message);
    }

    isConnectionLost(err: any): boolean {
        try {
            if (typeof navigator !== 'undefined' && navigator.onLine === false) {
                return true;
            }
        } catch (e) { /* noop */ }

        if (err == null) {
            return true;
        }

        const status = err.status;
        // Angular Http / XHR: 0 usually means no response (offline, DNS, CORS blocked as network)
        if (status === 0 || status === '0') {
            return true;
        }
        if (status == null || status === undefined || status === '') {
            const name = (err.name || '').toString().toLowerCase();
            const msg = (err.message || '').toString().toLowerCase();
            if (name.indexOf('timeout') !== -1 || msg.indexOf('timeout') !== -1) {
                return true;
            }
            if (msg.indexOf('failed to fetch') !== -1
                || msg.indexOf('network') !== -1
                || msg.indexOf('offline') !== -1
                || msg.indexOf('failed to load') !== -1) {
                return true;
            }
            // No HTTP status at all → treat as connection issue
            if (!err.statusText && !err._body && !err.error) {
                return true;
            }
        }
        return false;
    }

    private extractErrorMessage(source: any): string {
        if (source == null) {
            return '';
        }
        if (typeof source === 'string') {
            return source.trim().slice(0, 240);
        }

        let raw: any = null;
        try {
            if (source.error != null) {
                raw = source.error;
            } else if (source._body != null) {
                raw = source._body;
            } else if (source.message && source.status == null && !source.statusText) {
                // plain object / Response-like with message only
                raw = source.message;
            }
        } catch (e) {
            raw = null;
        }

        if (raw != null) {
            if (typeof raw === 'string') {
                const trimmed = raw.trim();
                if (!trimmed) {
                    // fall through to statusText
                } else {
                    try {
                        const parsed = JSON.parse(trimmed);
                        const fromJson = parsed.message || parsed.error || parsed.msg || parsed.title;
                        if (fromJson) {
                            return String(fromJson).trim().slice(0, 240);
                        }
                    } catch (e) { /* not JSON */ }
                    return trimmed.slice(0, 240);
                }
            } else if (typeof raw === 'object') {
                const fromObj = raw.message || raw.error || raw.msg || raw.title;
                if (fromObj) {
                    return String(fromObj).trim().slice(0, 240);
                }
            }
        }

        if (source.message && source.status > 0) {
            // Prefer statusText over Angular's generic "Http failure response for ..."
            const msg = String(source.message);
            if (msg.indexOf('Http failure') === -1 && msg.indexOf('Response with status') === -1) {
                return msg.trim().slice(0, 240);
            }
        }

        if (source.statusText && String(source.statusText).toLowerCase() !== 'unknown error') {
            return String(source.statusText).trim().slice(0, 240);
        }

        if (source.error && typeof source.error === 'string') {
            return source.error.trim().slice(0, 240);
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/services/toast-service.ts